module.exports = __webpack_public_path__ + "img/mr.03b1458a.svg";